import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RouterService {
  constructor(private _router: Router) {}

  getCurrentComponentRoute() {
    let url = this._router.url;
    url = url.split('?')[0];
    const segments = url.split(/[\/?&]/);
    let privateIndex = segments.findIndex((segment) => segment === 'private');
    if (privateIndex !== -1 && privateIndex + 1 < segments.length) {
      if(segments[1] === "en") privateIndex++;
      return segments.slice(privateIndex + 1).join('/');
    } else {
      // Handle case when "private" segment is not found or there are no segments after it
      return '';
    }
  }
}
